document.addEventListener('DOMContentLoaded', () => {
  const dataLayerElements = document.querySelectorAll('[data-event]');

  dataLayerElements.forEach(el => {
    el.addEventListener('click', () => {
      const eventEvent = el.getAttribute('data-event');
      const eventFicheMetier = el.getAttribute('data-fiche_metier');
      const eventMetier = el.getAttribute('data-metier');
      const eventName = el.getAttribute('data-name');
      const eventThema = el.getAttribute('data-thematique');
      const eventLabel = el.getAttribute('data-label');
      const eventPosition = el.getAttribute('data-position');
      const eventEventName = el.getAttribute('data-event-name');
      const eventEventThematique = el.getAttribute('data-event-thematique');


      if (eventEvent == 'telechargement_fiche_metier') {
        window.dataLayer.push({
          'event': eventEvent,
          'fiche_metier': eventFicheMetier,
          'metier': eventMetier,
        });
      }

      if (eventEvent == 'telechargement_kit_communication') {
        window.dataLayer.push({
          'event': eventEvent,
        });
      }

      if (eventEvent == 'clic_article') {
        window.dataLayer.push({
          'event': eventEvent,
          'article_name': eventName,
          'article_thematique': eventThema,
        });
      }

      if (eventEvent == 'clic_opco_sante_header') {
        window.dataLayer.push({
          'event': eventEvent,
        });
      }

      if (eventEvent == 'clic_cta') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_cta' : {
            'label' : eventLabel,
            'position' : eventPosition
          }
        });
      }

      if (eventEvent == 'clic_carte_metier') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_carte_metier' : {
            'label' : eventLabel,
          }
        });
      }

      if (eventEvent == 'clic_inscription_evenement') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_inscription_evenement' : {
            'event_name' : eventEventName,
            'event_thematique' : eventEventThematique,
          }
        });
      }

      if (eventEvent == 'clic_inscription_evenement') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_inscription_evenement' : {
            'event_name' : eventEventName,
            'event_thematique' : eventEventThematique,
          }
        });
      }
    });
  });
})
